var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeWhite500Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.61,145.34c-5.02-18.64-19.71-33.33-38.35-38.35C386.2,97.67,250,97.67,250,97.67s-136.2,0-170.25,8.96 c-18.28,5.02-33.33,20.07-38.35,38.71C32.43,179.39,32.43,250,32.43,250s0,70.97,8.96,104.66c5.02,18.64,19.71,33.33,38.35,38.35 c34.41,9.32,170.25,9.32,170.25,9.32s136.2,0,170.25-8.96c18.64-5.02,33.33-19.71,38.35-38.35c8.96-34.05,8.96-104.66,8.96-104.66 S467.93,179.39,458.61,145.34z M206.63,315.23V184.77L319.89,250L206.63,315.23z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite500Px);
export default __webpack_public_path__ + "static/media/youtube_white_500px.951ec1aaab375acb75fd55b74c5244e6.svg";
export { ForwardRef as ReactComponent };